import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropup",
  "use": "icon-dropup-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol viewBox=\"0 0 14 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dropup\">\n<path d=\"M0.995226 7.0022L6.99645 1.00097L12.9977 7.0022\" stroke=\"#999999\" stroke-width=\"1.7169\" stroke-linejoin=\"bevel\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol